import siteHealthStore from './store';

import { preferencesConfigAction } from './actions';

const siteHealthActions = {
  preferencesConfigAction,
};

export { siteHealthStore, siteHealthActions };
